







































import Vue from "vue";
import Header from "@/components/share/Header.vue";
import NavigationBar from "./components/share/NavigationBar.vue";
import { mapGetters } from "vuex";
import { shareDataService, ShareDataService } from "@/service/sharedataservice";
import GlobalDialog from "@/components/share/GlobalDialog.vue";
import axiosconfigurator from "@/global/config/axiosconfiguartor";
import { Component, Watch } from "vue-property-decorator";
import { authenticationRepository } from "./repositories/authenrepository";
import store from "./store";
import { User } from "./store/users/types";
import i18n from "./translations";
import { UserModel } from "./models/usermodel";
import { AppMutation } from "./store/app/types";

interface BreadCrumb {
  path: string;
  text: string;
}

@Component({
  components: {
    Header,
    NavigationBar,
    GlobalDialog,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "isAuthenticated",
      isNavExpanded: "isNavExpanded",
      user: "getUserProfile",
      language: "getLanguage",
    }),
  },
})
export default class App extends Vue {
  public isAuthenticated: boolean;
  public isNavExpanded: boolean;
  public user: UserModel;
  public showButton: boolean = false;
  public timeOutScroll: number = 0;
  public shareDataService: ShareDataService = shareDataService;
  public language: string | undefined;

  public created() {
    i18n.locale = this.language || "en";
    window.addEventListener("scroll", this.handleScroll);
    const token = window.localStorage.token ? window.localStorage.token : null;
    if (token) {
      axiosconfigurator._configAxiosToken(token, true);
      this.loadUserInfo();
    }
  }

  @Watch("language")
  public onLanguageChanged(value: string | undefined) {
    i18n.locale = value || "en";
  }

  public async loadUserInfo() {
    const user = await authenticationRepository.getUserInfo();
    if (user) {
      store.commit(User.SET_USERPROFILE, user);
      store.commit(AppMutation.SET_LANGUAGE, user.lang);
    }
  }

  public destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  public handleScroll(event: Event) {
    this.showButton = true;
    if (this.timeOutScroll) {
      clearTimeout(this.timeOutScroll);
    }
    this.timeOutScroll = setTimeout(() => {
      this.showButton = false;
    }, 3000);
  }

  public goTop() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }

  public get crumbs() {
    const pathArray = this.$route.path.split("/");
    pathArray.shift();
    const breadcrumbs: BreadCrumb[] = pathArray.reduce(
      (breadcrumbArray: BreadCrumb[], path, idx) => {
        if (
          this.$route.matched[idx] &&
          this.$route.matched[idx].meta.breadCrumb
        ) {
          breadcrumbArray.push({
            path,
            text:
              this.$route.matched[idx] &&
              this.$route.matched[idx].meta.breadCrumb,
          });
        }
        return breadcrumbArray;
      },
      [],
    );
    return breadcrumbs;
  }

  public get isShowNavigation() {
    return this.isAuthenticated && this.$route.path !== "/customer/feedback";
  }
}
